import { render } from "./PageOptionAttributesContainer.vue?vue&type=template&id=863c8796"
import script from "./PageOptionAttributesContainer.vue?vue&type=script&lang=js"
export * from "./PageOptionAttributesContainer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__